import React from 'react';
import { Button, IconButton, Paper, DialogTitle, DialogContent, DialogActions, TextField, Tooltip, Divider, Checkbox, FormControl, FormControlLabel, } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, TransferList, UploadFiles } from '../include';
import _ from 'underscore';

const strFillPattern = ". "

class EditTreatment extends React.Component {
  constructor(props) {
    super(props); 
    
    this.state = { 
      treatmentID: this.props.row ? this.props.row.id : -1,
      company_id: this.props.row ? this.props.row.company_id : this.props.user.company_id,
      name: this.props.row ? this.props.row.name : '', 
      end_after_days: this.props.row ? this.props.row.end_after_days : 1, 
      avaiable: this.props.row ? this.props.row.avaiable : true,
      pop_file_id: this.props.row ? this.props.row.pop_file_id : -1,
      previous_pop_file_id: this.props.row ? this.props.row.pop_file_id : -1,
      contract_template_file_id: this.props.row ? this.props.row.contract_template_file_id : -1,
      previous_contract_template_file_id: this.props.row ? this.props.row.contract_template_file_id : -1,
      tcle_template_file_id: this.props.row ? this.props.row.tcle_template_file_id : -1,
      previous_tcle_template_file_id: this.props.row ? this.props.row.tcle_template_file_id : -1,
      postreatment_template_file_id: this.props.row ? this.props.row.postreatment_template_file_id : -1,
      previous_postreatment_template_file_id: this.props.row ? this.props.row.postreatment_template_file_id : -1,
      legal_representative_template_file_id: this.props.row ? this.props.row.legal_representative_template_file_id : -1,
      previous_legal_representative_template_file_id: this.props.row ? this.props.row.legal_representative_template_file_id : -1,
      planning_background_file_id : this.props.row ? this.props.row.planning_background_file_id : -1,
      previous_planning_background_file_id : this.props.row ? this.props.row.planning_background_file_id : -1,
      treatment_form_template_file_id : this.props.row ? this.props.row.treatment_form_template_file_id : -1,
      previous_treatment_form_template_file_id : this.props.row ? this.props.row.treatment_form_template_file_id : -1,
      evaluation_form_template_file_id : this.props.row ? this.props.row.evaluation_form_template_file_id : -1,
      previous_evaluation_form_template_file_id : this.props.row ? this.props.row.evaluation_form_template_file_id : -1,
      anamnesis_template_file_id : this.props.row ? this.props.row.anamnesis_template_file_id : -1,
      previous_anamnesis_template_file_id : this.props.row ? this.props.row.anamnesis_template_file_id : -1,
      questionnaires_selected: null,
      questionnaires_unselected: null,
      medication: this.props.row ? this.props.row.medication : ''
    };
  }



  componentDidMount() {
    var theID = this.props.row ? this.props.row.id : -1;
    this.setState({ loading: true });   
    this.props.api
      .get('/Treatment/' + theID, { params: { company_id: this.state.company_id } })
      .then((r) => {
        var selected = [];
        var unselected = [];
        for(let row in r.selected){
          selected.push (r.selected[row].id + strFillPattern + r.selected[row].name );
        }
        for(let row in r.unselected){
          unselected.push( r.unselected[row].id + strFillPattern + r.unselected[row].name );
        }
        this.setState({
          questionnaires_selected: selected,
          questionnaires_unselected: unselected,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }
  
  

  handleSubmit = () => {
    var questionnairesIDs = [];
    for(var row in this.state.questionnaires_selected){
          var v = this.state.questionnaires_selected[row].split(strFillPattern)
          questionnairesIDs.push(v[0])
    }
    
    if (!this.props.edit) {
      this.props.api
        .post('/Treatments/', { company_id: this.state.company_id, name: this.state.name, end_after_days: this.state.end_after_days, avaiable: this.state.avaiable, pop_file_id: this.state.pop_file_id, contract_template_file_id: this.state.contract_template_file_id, tcle_template_file_id: this.state.tcle_template_file_id, postreatment_template_file_id: this.state.postreatment_template_file_id, legal_representative_template_file_id: this.state.legal_representative_template_file_id, planning_background_file_id: this.state.planning_background_file_id, treatment_form_template_file_id: this.state.treatment_form_template_file_id, evaluation_form_template_file_id: this.state.evaluation_form_template_file_id, anamnesis_template_file_id: this.state.anamnesis_template_file_id, questionnairesIDs: questionnairesIDs, medication: this.state.medication })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Registro criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Treatment/' + this.props.row.id, { id: this.props.row.id, company_id: this.state.company_id, name: this.state.name, end_after_days: this.state.end_after_days, avaiable: this.state.avaiable, pop_file_id: this.state.pop_file_id, previous_pop_file_id: this.state.previous_pop_file_id, contract_template_file_id: this.state.contract_template_file_id, previous_contract_template_file_id: this.state.previous_contract_template_file_id, tcle_template_file_id: this.state.tcle_template_file_id, previous_tcle_template_file_id: this.state.previous_tcle_template_file_id, postreatment_template_file_id: this.state.postreatment_template_file_id, previous_postreatment_template_file_id: this.state.previous_postreatment_template_file_id, legal_representative_template_file_id: this.state.legal_representative_template_file_id, previous_legal_representative_template_file_id: this.state.previous_legal_representative_template_file_id, planning_background_file_id: this.state.planning_background_file_id, previous_planning_background_file_id: this.state.previous_planning_background_file_id, treatment_form_template_file_id: this.state.treatment_form_template_file_id, previous_treatment_form_template_file_id: this.state.previous_treatment_form_template_file_id, evaluation_form_template_file_id: this.state.evaluation_form_template_file_id, previous_evaluation_form_template_file_id: this.state.previous_evaluation_form_template_file_id, anamnesis_template_file_id: this.state.anamnesis_template_file_id, previous_anamnesis_template_file_id: this.state.previous_anamnesis_template_file_id, questionnairesIDs: questionnairesIDs, medication: this.state.medication })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };
  
    
  handleQuestionnairesChange = (v) => {
    this.setState({questionnaires_selected: v})
  };
  
  
  
  handleDBRecord = (record, error, type) => {
    if(!error){
      if(type === "pop") 
        this.setState({pop_file_id: record.id });
      if(type === "contrato") 
        this.setState({contract_template_file_id: record.id });
      if(type === "tcle") 
        this.setState({tcle_template_file_id: record.id });
      if(type === "postrat") 
        this.setState({postreatment_template_file_id: record.id });
      if(type === "replegal") 
        this.setState({legal_representative_template_file_id: record.id });
      if(type === "planotratamento") 
        this.setState({planning_background_file_id: record.id });
      if(type === "fichatratamento") 
        this.setState({treatment_form_template_file_id: record.id });
      if(type === "fichaavaliacao") 
        this.setState({evaluation_form_template_file_id: record.id });
      if(type === "anamnese") 
        this.setState({anamnesis_template_file_id: record.id });
    }
  }
  
  
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Tratamento' : 'Adicionar Tratamento'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          {(this.props.user.role==="superuser") &&
            <>
              <TextField
                fullWidth
                variant="outlined"
                label="Empresa"
                value={this.state.company_id}
                onChange={(e) => this.setState({ company_id: e.target.value })}
                required
              />
              <D h="1rem" />
            </>
          }
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Dias para Encerramento"
            value={this.state.end_after_days}
            onChange={(e) => this.setState({ end_after_days: e.target.value })}
            required
          />
          <D h="1rem" /> 
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.avaiable} 
              onChange={(e) => this.setState({ avaiable: e.target.checked })} 
            />
          } label="Disponível para uso" />   
          <D h="1rem" /> 
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "pop") }}
            registerIntoDB={true}
            caption="POP"
          />    
          <TextField
            fullWidth
            variant="outlined"
            label="POP"
            value={this.state.pop_file_id}
            onChange={(e) => this.setState({ pop_file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "contrato") }}
            registerIntoDB={true}
            caption="Modelo de Contrato"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Contrato"
            value={this.state.contract_template_file_id}
            onChange={(e) => this.setState({ contract_template_file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "tcle") }}
            registerIntoDB={true}
            caption="Modelo de TCLE"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de TCLE"
            value={this.state.tcle_template_file_id}
            onChange={(e) => this.setState({ tcle_template_file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "postrat") }}
            registerIntoDB={true}
            caption="Modelo de Pós-Tratamento"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Pós-Tratamento"
            value={this.state.postreatment_template_file_id}
            onChange={(e) => this.setState({ postreatment_template_file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "replegal") }}
            registerIntoDB={true}
            caption="Modelo de Representante Legal"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Representante Legal"
            value={this.state.legal_representative_template_file_id}
            onChange={(e) => this.setState({ legal_representative_template_file_id: e.target.value })}
            required
          />          
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "fichatratamento") }}
            registerIntoDB={true}
            caption="Modelo de Ficha de Tratamento"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Ficha de Tratamento"
            value={this.state.treatment_form_template_file_id}
            onChange={(e) => this.setState({ treatment_form_template_file_id: e.target.value })}
            required
          />          
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "fichaavaliacao") }}
            registerIntoDB={true}
            caption="Modelo de Ficha de Avaliação"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Ficha de Avaliação"
            value={this.state.evaluation_form_template_file_id}
            onChange={(e) => this.setState({ evaluation_form_template_file_id: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "anamnese") }}
            registerIntoDB={true}
            caption="Modelo de Anamnese"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo de Anamnese"
            value={this.state.anamnesis_template_file_id}
            onChange={(e) => this.setState({ anamnesis_template_file_id: e.target.value })}
            required
          />
          <D h="1rem" /> 
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".jpg, .png, .jpeg"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "planotratamento") }}
            registerIntoDB={true}
            caption="Imagem de Fundo do Plano de Tratamento"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Imagem de Fundo do Plano de Tratamento"
            value={this.state.planning_background_file_id}
            onChange={(e) => this.setState({ planning_background_file_id: e.target.value })}
            required
          />
          <D h="1rem" />             
          <FormControl fullWidth>
          { this.state.questionnaires_selected && this.state.questionnaires_unselected &&
            <TransferList
              caption="Questionários" 
              alternative={this.state.questionnaires_unselected}
              assignment={this.state.questionnaires_selected}
              onAssignmentChange={this.handleQuestionnairesChange}
            />
          }
          </FormControl>  
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Medicação Padrão"
            multiline
            value={this.state.medication}
            onChange={(e) => this.setState({ medication: e.target.value })}
          />    
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Treatment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 60 },
      { field: 'company_id', headerName: 'Empresa', width: 90 },
      { field: 'name', headerName: 'Nome', width: 300 },
      { field: 'end_after_days', headerName: 'Dias para Encerramento', width: 120 },
      { field: 'avaiable', headerName: 'Disponível', width: 90 },
      { field: 'pop_file_id', headerName: 'POP', width: 70 },
      { field: 'contract_template_file_id', headerName: 'Contrato', width: 90 },
      { field: 'tcle_template_file_id', headerName: 'TCLE', width: 70 },
      { field: 'postreatment_template_file_id', headerName: 'Pós-Tratamento', width: 120 },
      { field: 'legal_representative_template_file_id', headerName: 'Representante Legal', width: 120 },
      { field: 'treatment_form_template_file_id', headerName: 'Ficha de Tratamento', width: 120 },
      { field: 'evaluation_form_template_file_id', headerName: 'Ficha de Avaliação', width: 120 },
      { field: 'anamnesis_template_file_id', headerName: 'Anamnese', width: 120 },
      { field: 'planning_background_file_id', headerName: 'Background do Plano de Tratamento', width: 120 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Treatments', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        /*for(var row in r.treatments){
          if(r.treatments[row]["template_file_id"] == "null")
            r.treatments[row]["template_file_id"] = -1;
          
        }*/
        this.setState({
          dataTable: r.treatments || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditTreatment
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Treatment/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditTreatment
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                        user={this.props.user}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}


